import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ams } from 'src/app/amsconfig';
import { BehaviorSubject } from 'rxjs';
import { IFeatureFlags } from 'src/app/core/dto';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  features: IFeatureFlags = {};
  features$: BehaviorSubject<IFeatureFlags> = new BehaviorSubject<IFeatureFlags>({});

  constructor(private http: HttpClient) {
    this.refresh();
  }

  featureDisabled(feature) {
    return feature.split(';').every((f) => this.features[f] === false);
  }

  private getFeatures() {
    return this.http.get<IFeatureFlags>(`${Ams.Config.BASE_URL}/api/features`);
  }

  refresh() {
    this.getFeatures().subscribe((features) => {
      this.features = { ...features, ...this.features };
      this.features$.next(this.features);
    });
  }

  setFeature(feature: string, enabled: boolean) {
    return this.http.post(`${Ams.Config.BASE_URL}/api/features/${feature}?enabled=${enabled}`, {});
  }
}
